import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const internalReferenceFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'SearchFilter',
        operation: 'contains',
      },
    ],
    onUpdateValue: () => {
      trackFilters('internalReference', expensesContext)
    },
    identifier: 'expensesList.internalReferenceFilter',
    path: 'internalReference',
    title: i18n.t('expenses_v2.forms.fields.reference.label'),
  }
}

export default internalReferenceFilter
